import Image from "next/image";

import Link from "next/link";
import { Navigation } from "swiper/modules";
import { Swiper, SwiperSlide } from "swiper/react";
import { Money } from "../../Money";
import IconStopwatch from "../../icons/IconStopwatch";
import IconDiscount2 from "../../icons/discount";


type SpecialDiscounted = {
  specialDiscounted: any;
  className?: string;
}


// eslint-disable-next-line import/no-default-export
export default function SpecialDiscount(props: SpecialDiscounted) {
  const { specialDiscounted, className } = props;

  return (<div className={`flex flex-row p-5  text-white text-xl h-[380px] w-[95%] mx-auto mt-16 rounded-2xl overflow-hidden  bg-secondary-500 ${className}`}>
    <div className="relative flex flex-col gap-4 items-center align-middle w-[180px]   sm:w-[260px]  sm:min-w-[260px] h-full justify-center text-xl sm:text-2xl font-medium bg-secondary-500">
      {/* <Image src="/widgets/discount.svg" className="h-[348px] top-[-34px] left-[-43px] absolute bg-white " alt="" width={100} height={20} /> */}
      <IconDiscount2 width={50} height={50} />
      <p> پیشنهادات</p>
      <p> شگفت انگیز</p>
    </div>


    <Swiper
      modules={[Navigation]}
      navigation
      breakpoints={{
        1: {
          slidesPerView: 1,
        },
        650: {
          slidesPerView: 2,
        },
        840: {
          slidesPerView: 3,
        },
        1100: {
          slidesPerView: 4,
        },
      }}
      slidesPerView={4}
      spaceBetween={20}
      defaultValue={4}
      className="p-3 m-2"
    >

      {specialDiscounted?.map((product) => (
        <SwiperSlide key={product?.id} className="relative flex p-3 flex-col bg-white items-center rounded-lg  w-full overflow-hidden">
          <Link href={`/p/${product?.url_key}`}>
            <div className="max-w-48 h-auto m-auto">
              <Image width={100} height={100} src={product?.image?.url} alt="" />
            </div>
            <div className="text-sm text-center text-default-900 truncate ">
              {product.name}
            </div>
            <div className="w-full flex flex-row items-center justify-between align-middle">
              {product?.price_range?.minimum_price?.discount?.percent_off > 0 &&
                <span className="w-9 h-9 bg-error-500  text-center text-sm text-white flex items-center justify-center p-1 rounded-sm">
                  %{Math.round(product?.price_range?.minimum_price?.discount?.percent_off)}
                </span>}
              <div className="flex flex-row items-center justify-center">

                <div className="w-full flex flex-col justify-between items-center mt-3">
                  <span className="text-base text-secondary-500 font-semibold ">
                    <Money showCurrency={false} {...product?.price_range?.minimum_price?.final_price} />
                  </span>
                  <span className="text-sm text-light-400 line-through">
                    {product?.price_range?.minimum_price?.discount?.percent_off > 0 && <Money showCurrency={false} {...product?.price_range?.minimum_price?.regular_price} />}
                  </span>
                </div>
                <span className="text-default-700 text-xs rotate-90  " >تومان</span>
              </div>

            </div>
            {product?.price_range?.minimum_price?.discount?.percent_off > 0 &&
              <span style={{ direction: 'ltr' }} className="bg-error-500 flex flex-row align-middle px-2 py-1 absolute left-2 top-2 text-center text-sm text-white items-center justify-center rounded-3xl">
                <IconStopwatch width={20} height={20} />
                260 : 13 : 20 : 45
              </span>}
          </Link>

        </SwiperSlide>

      ))}
    </Swiper>

  </div >)
}